import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import Home from "./Home/Home";
import About from "./component/About/About";
import Department from "./component/Department/Department";
import Faculties from "./component/Faculties/Faculties";
import Academics from "./component/Academics/Academics";
import AdminLogin from "./component/Admin/AdminLogin";
import AdminDashboard from "./component/Admin/AdminDashboard";

function App() {
  return (
    <Router>
      <div className="App">
        <main>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/academics" element={<Academics />} />
            <Route path="/department" element={<Department />} />
            <Route path="/faculties" element={<Faculties />} />
            
            {/* Admin Routes */}
            <Route path="/admin/AdminLogin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
}

export default App;
